module.exports = __webpack_public_path__ + "img/logo-dark.4013fd4d.png";